var map = {
	"./BannerContactWidget.vue": 16656,
	"./BannerWidget.vue": 57088,
	"./BaseWidgetForm.vue": 17724,
	"./BudgetWidget.vue": 25592,
	"./BulletedListWithMediaWidget.vue": 20908,
	"./CTAWidget.vue": 97056,
	"./ContactWidget.vue": 46072,
	"./ContentWidget.vue": 7410,
	"./DonateWidget.vue": 34870,
	"./DynamicFormWidget.vue": 35976,
	"./FilesWidget.vue": 55748,
	"./FullVideoWidget.vue": 91008,
	"./GalleryWidget.vue": 86292,
	"./HelpInStepsWidget.vue": 77324,
	"./IframeWidget.vue": 79272,
	"./ImageWidget.vue": 44816,
	"./PartnerWidget.vue": 63128,
	"./PeopleListWidget.vue": 67284,
	"./SimilarArticlesWidget.vue": 58968,
	"./SimpleButtonWidget.vue": 32660,
	"./StepWidget.vue": 27784,
	"./TextLeadWidget.vue": 85972,
	"./TextMediaWidget.vue": 95848,
	"./TitleLeadWidget.vue": 82840,
	"./TitleListWidget.vue": 26964,
	"./WsPartnerWidget.vue": 54120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14356;